import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const entries = <T extends { [k: PropertyKey]: unknown }>(obj: T) => {
  return Object.entries(obj) as T extends { [K in infer P]: infer V }
    ? string | number extends P
      ? [string, V][]
      : [P, V][]
    : [keyof T, T[keyof T]][]
}

/**
 * Upload a file to S3 using a presigned URL with proper Content-Type header
 */
export const uploadToS3 = async (
  uploadUrl: string,
  file: Blob | File,
  contentType?: string,
): Promise<Response> => {
  const type = contentType || ('type' in file ? file.type : undefined) || 'application/octet-stream'
  return fetch(uploadUrl, {
    method: 'PUT',
    body: file,
    headers: { 'Content-Type': type },
  })
}

export const formatDate = (dateStr: string): string => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]
  const d = new Date(dateStr)
  const month = months[d.getMonth()]
  const day = d.getDate()
  return `${month} ${day}`
}
